// Who took a card's photo, on the photo itself: a Wikimedia licence asks for it. The card's
// credit already names the source ("… · CC BY-SA · Wikimedia Commons").
const SHOWN = new Set(["wikimedia"]);

export const PhotoCredit = ({ source, credit }) => (SHOWN.has(source) && credit ? (
  <span className="absolute truncate" title={credit}
    style={{ right: 6, bottom: 6, maxWidth: "70%", fontSize: 9, lineHeight: "14px", color: "#F5F5F0",
             background: "rgba(30,26,21,.68)", padding: "1px 6px", borderRadius: 3, pointerEvents: "none" }}>
    {credit}
  </span>
) : null);

export default PhotoCredit;
